<template>
  <div class="news-detail">
    <h2>{{ datum.title }}</h2>
    <div class="intro">
      <div class="author">
        <!-- <img v-if="datum.authorHead" :src="datum.authorHead" alt="" />
        <img
          v-else
          :src="require('../../assets/images/home/unuser_head.svg')"
          alt=""
        />
        <p>{{ datum.authorName }}</p> -->
        <span>{{ datum.time }}</span>
      </div>
      <!-- <div class="intro-content">{{ datum.intro }}</div> -->
    </div>
    <div class="news-content" v-html="datum.content"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      datum: {
        title: "标题",
        authorName: "作者",
        time: "2021 12/22 11:12",
        intro:
          "书画艺术创作成果，首届出彩少年“智慧练字”杯全国青少年书画创作大赛成功启动，并面向全国公开征稿。",
        content: `<p><img src="${require("../../assets/images/home/test-new-pic.png")}" /></p><p><span>★ 作品主题：要求内容健康向上，作品风格不限。</span></p><p><span>★ 征稿对象：面向海内外大中专、中学、小学、幼儿园、少年活动中心、青少年宫、文化馆及社会兴办的书画培训报名服务单位的学员。分为幼儿组（6岁以下）、少儿组（7-12岁）、少年组（13-17岁）、青年组（18-29周岁）。</span></p><p><span>★ 参赛项目：1.书法：软笔书法。2.硬笔书法：钢笔、圆珠笔、铅笔等均可。3.篆刻。4.美术：国画、油画、水粉画、水彩、版画、素描、儿童画、彩笔、蜡笔、漫画、电脑绘画、剪纸、布贴、陶艺、泥塑、摄影类。（一人可投稿多幅作品，同类作品只能提交一幅）</span></p><p><span>★ 作品要求：作品尺寸不限，电子投稿要求参赛图片清晰，光线明亮，画面完整。</span></p><p><span>投稿须知</span></p><p><span>★ 参评费用：个人参赛评审费人民币58元/幅，集体组织参赛人民币35元/幅；海外及港澳台地区20美元/幅。</span></p><p><span>1、邮寄作品背面右下角请用铅笔注明作者姓名、性别、年龄、指导老师、电话、地址，并排好顺序，须与《参赛登记表》一致。集体参赛电子投稿则需要在照片文件名上标注“序号和作者姓名”。（限于人力，邮寄原稿一律不退。）</span></p><p><span>2、凡组织10人以上参赛列为集体参赛单位，请组织老师统一列表、统一投稿。</span></p><p><span>3、请指导老师为学生作品进行初评，作为组委会评审的参考。</span></p>`
      }
    };
  },
  mounted() {
    const data = window.localStorage.getItem("home_news_detail_infos");
    this.datum = JSON.parse(data);
  }
};
</script>
<style lang="scss" scoped>
.news-detail {
  text-align: left;
  width: 100%;
  max-width: 10rem;
  height: 100%;
  padding: 20px;
  h2 {
    font-size: 18px;
    font-weight: 700;
    color: #666;
    line-height: 28px;
    margin: 0;
  }
  .intro {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f2f2f2;
    .author {
      height: 30px;
      display: flex;
      align-items: center;
      margin-top: 12px;
      img {
        width: 24px;
        height: 24px;
      }
      p {
        margin-left: 5px;
        font-size: 13px;
        color: #666;
      }
      span {
        margin-left: 5px;
        color: #999;
      }
    }
    .intro-content {
      margin-top: 15px;
      font-size: 13px;
      color: #999;
      text-align: justify;
    }
  }
}
</style>
<style lang="scss">
.news-detail {
  .news-content {
    img {
      width: 100%;
    }
    p {
      line-height: 28px;
      font-size: 13px;
      color: #333333;
    }
  }
}
</style>
